import { lazy } from "react"

export const DepotsPage = lazy(() => import("./DepotsPage"))